export default function Processing() {
  return (
    <>
      <div className="screen active" id="screen-processing">
        <div className="page-head">
          <div>
            <h1>Processing</h1>
            <div className="ph-sub">
              Live status as each bill is sent to the biller
            </div>
          </div>
        </div>
        <div className="card">
          <div className="progress-track" style={{ marginBottom: 8 }}>
            <div className="progress-fill" id="proc-fill" />
          </div>
          <div
            style={{
              fontSize: "11.5px",
              color: "var(--text-faint)",
              marginBottom: 18,
            }}
            id="proc-label"
          >
            Waiting to start…
          </div>
          <div className="table-wrap">
            <table className="data-table" id="proc-table" />
          </div>
          <button
            className="btn btn-primary"
            id="proc-view-btn"
            style={{ marginTop: 16, display: "none" }}
            onclick="go(null,'screen-success')"
          >
            View results
          </button>
        </div>
      </div>
    </>
  );
}
